import React, { useState } from 'react';
import { session } from 'services/session';

import CreateLink from './create-link';
import CreatedLinks from './created-links';

import './link-creation.scss';

function LinkCreation() {
	const [isCreateTab, setTab] = useState(true);
	const tab = isCreateTab ? <CreateLink /> : <CreatedLinks />;

	if (!session.isAdmin) return <h1>Page In Progress</h1>;
	return (
		<div className="link-creation">
			{tab}
			<div className="nav">
				<div className={`links-btn ${isCreateTab ? 'selected' : ''}`}
					onClick={() => setTab(true)}>
					Create New Link
				</div>
				<div className={`links-btn ${isCreateTab ? '' : 'selected'}`}
					onClick={() => setTab(false)}>
					Recently Created Links
				</div>
			</div>
		</div>
	);
}

export default LinkCreation;
